<template>
    <div>
      <form>
        <div v-if="!success">
            <input tyle="text" v-model="email" class="mb-3 form-control" @keydown.enter.prevent="subscribe" autocomplete="email" placeholder="Enter your email here!">
            <div class="alert alert-danger" v-show="error_message" v-html="error_message"></div>
            <div class="btn btn-primary d-block d-sm-inline-block" v-on:click.prevent="subscribe" v-if="!loading">Submit</div>
            <p class="text-right close-modal"><button style="background:none;border:none" class="pointer " @click.prevent="close()">No Thanks</button></p>
            <div class="btn btn-primary d-block d-sm-inline-block" v-if="loading">Loading...</div>
        </div>
        <div v-if="success">
            <h2>Success!</h2>
            <p class="display-5">Your code is: JOURNEY</p>
            <a href="/subscribe" class="btn btn-success">Start Your Subscription</a>
            <p>
            We've sent you a welcome email with 10% off our shop too!.
            </p>
            <button style="background:none;border:none" @click="close()">Close Message</button>
        </div>
      </form>
    </div>
</template>

<script>
    export default {
        data() {
            return  {
                email:null,
                loading: false,
                error_message: '',
                success: false,
            }       
        },
        http: {
            root: '/root',
            headers: {
                'X-CSRF-Token': Laravel.csrfToken
            }
        },
        mounted() {
            if(! this.$cookie.get('favorite-signup-2'))
            {
                $("#email-text").removeClass('d-none');
                var that = this;

                let el = document.getElementById("email-text")
                setTimeout( function() {
                    
            
                    swal({
                        closeOnClickOutside: false,
                        content: el,
                        buttons: {
                    
                        },

                        className : 'email-signup-2'
                    })
                    .then((e) => {
                      if (e) {
                        that.$cookie.set('favorite-signup-2', 'true', 999);
                      } else {
                        that.$cookie.set('favorite-signup-2', 'true', 999);
                        swal.close()
                      }
                    });
                },10000);
            }
        },
        methods: {
            close()
            {
                swal.close();
            },
            subscribe()
            {
                this.loading = true;

                var $data = {
                    'email' :      this.email,
                }
                this.$http.post(
                    '/ajax/newsletter/subscribe', 
                    $data
                ).then(function(success) {
                     this.loading = false;
                     this.success = true;
                     $("#email-text .success-text").addClass('d-none');
                     this.$cookie.set('favorite-signup-2', 'true', 999);
                }, function(error) {
                    this.error_message = error.body.message;
                     this.loading = false;
                });
            }
        }
    };
</script>
